/* esm.sh - applesauce-core@5.2.0/promise */
export * from "/*applesauce-core@5.2.0/esnext/promise.mjs";
